export default __webpack_public_path__ + "static/media/Aria.5a6593da.png";